import request from "../utils/request";

export function categorize() {
  return request({
    url: '/system/dict/netDict/product_categorize',
    method: 'get',
  })
}

export function getBanner() {
  return request({
    url: '/app/banner/list',
    method: 'get',
  })
}

export function getdpzb() {
  return request({
    url: '/app/store/list',
    method: 'get',
  })
}
export function getStoreList() {
  return request({
    url: '/app/store/list',
    method: 'get',
  })
}

export function getStoreDetail(id) {
  return request({
    url: '/app/store/'+id,
    method: 'get',
  })
}

export function pageList(param) {
  return request({
    url: '/app/product/page?categorize='+param.categorize+'&current='+param.current+'&size='+param.size,
    method: 'get',
  })
}
export function allProduct(param) {
  return request({
    url: '/app/product/page?current='+param.current+'&size='+param.size,
    method: 'get',
  })
}

export function detail(id) {
  return request({
    url: '/app/course/'+id,
    method: 'get',
  })
}
export   function contactlatest() {
  return request({
    url: '/app/contact/latest',
    method: 'get',
  })
}
export async function contactlatestasync() {
  return request({
    url: '/app/contact/latest',
    method: 'get',
  })
}
export function sendcode(phone) {
  return request({
    url: '/app/joinUsers/sms/sendcode?phone='+phone,
    method: 'get',
  })
}

export function saveJoin(data) {
  return request({
    url: '/app/joinUsers/save',
    data: data,
    method: 'post',
  })
}
export function brandlatest() {
  return request({
    url: '/app/brand/latest',
    method: 'get',
  })
}

export function companylatest() {
  return request({
    url: '/app/company/latest',
    method: 'get',
  })
}

export function getbrandList() {
  return request({
    url: '/app/brand/list',
    method: 'get',
  })
}

export function brandDetail(id) {
  return request({
    url: '/app/brand/'+id,
    method: 'get',
  })
}




// WEBPACK FOOTER //
// ./src/api/index.js